define('shoptheme/components/product/wishlist',[
	"require",
	"jquery",
	"lodash",
	"cartware/components/_base",
	"gigaset/spinner",
	"text!shoptheme/templates/magnific-popup/default.html",
	"magnific-popup"
], function(
	require,
	$,
	_,
	Component,
	Spinner,
	PopupHtml
) {
	var popupTemplate = null;

	return Component.create({
		itemCount:				0,
		productIds:				null,
		customerIsLoggedIn:		(gigaset.handles.indexOf('customer_logged_in') !== -1),
		isSecure:				('https:' == document.location.protocol),
		config:					{
			controller: 		'wishlist/index/',
			cookiePrefix:		'wish_list',
			cookieSeparator:	'__'
		},

		$init: function() {
			var self = this;

			if (this.customerIsLoggedIn === false) {
				$('.wishlist-trigger').remove();
				$('.wishlist-link').remove();
				$('.b_wishlist-link').remove();
				// return;
			}

			self._initData();

			$(document).on('click', '.wishlist-trigger', function(e) {
				var element = $(e.currentTarget),
					parent = element.closest('.b_product-item__container'),
					addUrl = element.data('wishlist-add-url'),
					removeUrl = element.data('wishlist-remove-url');

				Spinner.add(parent);

				if (element.hasClass('active')) {
					self._sendRequest(removeUrl);
					element.removeClass('active');
				} else {
					if (self.itemCount == 0) {
						element.addClass('active');
					}
					self._sendRequest(addUrl);
				}
			});

			$(document).on('click', '.wishlist-link', function(e) {
				e.preventDefault();
				if(productAddToCartForm.validator) {

					var element = $(e.currentTarget),
						parent = element.closest('.b_product-add-to-links'),
						url = element.attr('href'),
						data,
						nv = Validation.methods;

					delete Validation.methods['required-entry'];
					delete Validation.methods['validate-one-required'];
					delete Validation.methods['validate-one-required-by-name'];
					// Remove custom datetime validators
					for (var methodName in Validation.methods) {
						if (methodName.match(/^validate-datetime-.*/i)) {
							delete Validation.methods[methodName];
						}
					}

					if (productAddToCartForm.validator.validate()) {
						Spinner.add(parent);
						data = $('#product_addtocart_form').serialize();
						self._sendRequest(url, data);
					}

					Object.extend(Validation.methods, nv);
				}
			});
		},
		_initData: function() {
			this.itemCount = Mage.Cookies
				.get(this.config.cookiePrefix + this.config.cookieSeparator + 'item_count') || 0;
			this.productIds = Mage.Cookies
				.get(this.config.cookiePrefix + this.config.cookieSeparator + 'product_ids') || [];
			if (typeof this.productIds === 'string') {
				this.productIds = this.productIds.split(',');
			}
			$('.wishlist-trigger.active','.b_product-item[data-product-id]').removeClass('active');
			_.forEach($('.wishlist-link'), function(link) {
				link = $(link);
				link.attr('href', link.data('add-url')).text(link.data('add-text'));
			});
			_.forEach(this.productIds, function(productId) {
				$('.wishlist-trigger','.b_product-item[data-product-id="'+productId+'"]').addClass('active');
				var removeLink = $('.wishlist-link[data-product="'+productId+'"]');
				removeLink.attr('href', removeLink.data('remove-url')).text(removeLink.data('remove-text'));
			});

			$('.b_wishlist-link__count').text(this.itemCount);
		},
		/**
		 * Send ajax request
		 *
		 * @param url
		 * @param data
		 * @private
		 */
		_sendRequest: function(url, data, callback) {
			var self = this;
			data = data || {};

			// add isAjax param to avoid caching problems
			if (url.indexOf("isAjax=1") === -1 && typeof data === 'string' && data.indexOf("isAjax=1") === -1) {
				url += url.indexOf("?") === -1 ? '?isAjax=1' : '&isAjax=1';
			}

			$.ajax(url, {
				method: "POST",
				data: data
			}).then(_.bind(function(response) {
				if (typeof callback === 'function') callback();
				Spinner.remove();
				if ((response.error || response.success === false) && response.message) {

					self._showMessage(response.message);
				}
				self._initData();

			}, this));
		},
		_renderPopup: function(data) {
			if (null === popupTemplate) {
				popupTemplate = _.template(PopupHtml);
			}

			return popupTemplate(data);
		},
		_showMessage: function(message) {
			$.magnificPopup.open({
				items: {
					src: this._renderPopup({ body: message }),
					type: 'inline'
				}
			});
		}
	});
});
